export default {"src":"/_next/static/media/arrow-right.4891ced5.svg","height":34,"width":59};